import { doc, getDoc, setDoc, deleteDoc, serverTimestamp } from 'firebase/firestore';
import { db } from './firebase';

// users/{uid}/private/meta (brief 035): the owner's private sign-up facts (how they
// heard about MedXMeet, invite codes). Only the owner can read or write it; it never
// goes on the public profile.
const metaRef = uid => doc(db, 'users', uid, 'private', 'meta');

export const readMeta = async uid => {
  const snap = await getDoc(metaRef(uid));
  return snap.exists() ? snap.data() : {};
};
export const saveMeta = (uid, data) => setDoc(metaRef(uid), { ...data, updatedAt: serverTimestamp() }, { merge: true });
export const deleteMeta = uid => deleteDoc(metaRef(uid));

// "How did you hear about MedXMeet?" (P-3): label and stored value.
export const SIGNUP_SOURCES = [
  ['invite', 'A study partner invited me'],
  ['word_of_mouth', 'A friend or classmate told me'],
  ['app_store', 'App Store search'],
  ['web_search', 'Google or another web search'],
  ['reddit', 'Reddit'],
  ['discord', 'Discord'],
  ['group_chat', 'Facebook, WhatsApp or Telegram group'],
  ['school_org', 'My school or a student organization'],
  ['linkedin', 'LinkedIn'],
  ['other', 'Other'],
];
export const isSignupSource = v => SIGNUP_SOURCES.some(([k]) => k === v);
